import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import iconYellowSearch from '../../assets/icon/icon-yellow-search.png';
import PopupLoginError from '../Popup/LoginError';
import { useLanguage } from '../../hooks/useLanguage';

function Search({ isOpen, onClose, isHoverMode = false }) {
  const { t } = useLanguage();
  const navigate = useNavigate();
  const [searchText, setSearchText] = useState('');
  const [isPopupLoginError, setIsPopupLoginError] = useState(false);
  const searchInputRef = useRef(null);

  if (!isOpen) return null;

  const handleSearch = () => {
    if (!searchText.trim()) {
      setIsPopupLoginError({
        message: '검색어를 입력해주세요.',
        action: 'maintain_ui'
      });
      return;
    }
    
    navigate(`/search?keyword=${encodeURIComponent(searchText)}`);
    onClose();
  };

  const handleConfirm = () => {
    setTimeout(() => {
      if (searchInputRef.current) {
        searchInputRef.current.focus();
      }
    }, 10);
  };

  return (
    <div 
      className="search-overlay" 
      onClick={(e) => {
        if (!isHoverMode && !isPopupLoginError) {
          onClose();
        }
      }}
      onMouseEnter={isHoverMode ? () => clearTimeout(window.searchHoverTimeout) : undefined}
      onMouseLeave={isHoverMode ? () => {
        window.searchHoverTimeout = setTimeout(() => {
          onClose();
        }, 100);
      } : undefined}
    >
      <div className="search-container"
        onClick={(e) => {
          // search-input-container나 search-text가 아닌 빈 공간을 클릭했을 때만 닫기
          if (e.target === e.currentTarget) {
            onClose();
          }
        }}
        onMouseLeave={isHoverMode ? onClose : undefined}
      >
        <div className="search-input-container"
          onClick={e => e.stopPropagation()}
        >
          <input 
            ref={searchInputRef}
            type="text" 
            className="search-input"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            onKeyUp={(e) => e.key === 'Enter' && handleSearch()}
          />
          <button 
            className="search-button" 
            onClick={handleSearch}
          >
            <img
              src={iconYellowSearch}
              alt="search"
              loading="lazy"
            />
          </button>
        </div>
        <p className="search-text" onClick={e => e.stopPropagation()}>{t('search_placeholder')}</p>
      </div>
      <PopupLoginError 
        isPopup={isPopupLoginError} 
        setIsPopup={setIsPopupLoginError}
        onConfirm={handleConfirm}
      />
    </div>
  );
}

export default Search;